// 印尼语
export const Indonesia = {
  language_code: "id",
  get_btn: "Tukar sekarang",
  unregistered_tip: "Pengguna yang belum terdaftar akan langsung membuat akun.",
  phone_number: "Nomor telepon",
  ver_code: "Kode verifikasi",
  get_ver_code: "Dapatkan kode",
  retrieve_ver_code: "Kirim ulang ({SECONDS})",
  age_tip:
    "Saya sudah dewasa dan memiliki kapasitas sipil penuh, serta setuju dengan ",
  and: " dan ",
  PRIVICY_POLICY: '"Kebijakan Privasi"',
  MEMBER_AGGREMENT: '"Ketentuan Keanggotaan"',
  agree_push:
    "Saya setuju menerima notifikasi Haidilao melalui nomor ponsel atau email yang terdaftar.",
  CN: "Tiongkok",
  US: "Amerika Serikat",
  CA: "Kanada",
  GB: "Britania Raya",
  MY: "Malaysia",
  AU: "Australia",
  ID: "Indonesia",
  SG: "Singapura",
  TH: "Thailand",
  JP: "Jepang",
  KR: "Korea",
  VN: "Vietnam",
  HK: "Hong Kong",
  MO: "Makau",
  HKM: "Kamboja",
  TW: "Taiwan",
  PH: "Filipina",
  UAE: "UEA",
  suc_send: "Terkirim",
  suc_get: "Penukaran Berhasil",
  fail_ver_code: "Kode salah",
  time_end: "Acara telah berakhir",
  not_get_repeat: "Tidak dapat ditukar lagi!",
  not_get_eligible: "Tidak bisa ditukar, tidak memenuhi syarat acara.",
  not_get_late: "Terlambat, acara sudah selesai.",
  get_coupon: "Ambil kupon",
  phone_err: "Nomor ponsel tidak valid. Harap masukkan nomor yang benar.",
  page_title: "Ambil kupon eksklusif Haidilao",
  send_code_error: "Kesalahan mengirim kode verifikasi",
  network_error:
    "Jaringan Anda saat ini tidak stabil, silakan coba lagi nanti.",
  member_status_abnormal: "Akun anggota bermasalah, tidak dapat mengambil",
  send_frequently:
    "Terlalu banyak kode verifikasi yang dikirim. Masukkan kode terakhir yang Anda terima atau coba lagi nanti.",
  activity_boom: "Terlalu banyak orang yang mengambil. Coba lagi nanti.",
  email: "Email",
  email_error_tip: "Email tidak valid. Harap masukkan email yang benar.",
  suc_get_dialog_text:
    "Buka aplikasi member Haidilao sekarang untuk melihat kupon yang telah diterima!",
  btn_sure: "OK",
  btn_cancel: "Batal",
  suc_dialog_text:
    "Buka aplikasi Haidilao atau tautkan keanggotaan Anda di LINE untuk melihat kupon yang sudah diterima!",
  btn_return: "Kembali",
  btn_download: "Unduh",
};
